module.exports = __webpack_public_path__ + "static/media/MCeb6ovzbww.104b4819.png";